export const SET_STORAGE = 'SET_STORAGE'


export const setLocalStorage = data =>({
    type:SET_STORAGE,
    payload:data
});